<div class="if-input-wrapper" [class.if-input-with-button]="button() || fakeButton()" [class.if-input-grouped]="grouped()">
  @if (icon()) {
  <div class="if-input-icon">
    @if (icon() === 'search') {
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
      class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
    </svg>
    }
  </div>
  }

  <ng-content select=".upload-control"></ng-content>
  <ng-content select=".prefix-control"></ng-content>

  <div class="if-input-container">
    @if (type() === 'textarea') {
    <textarea #textareaElement class="if-input" [placeholder]="placeholder()" [disabled]="disabled" [readonly]="readonly()"
      [value]="internalValue" (input)="onInput($event)" (blur)="onBlur()"
      [class.if-textarea-no-resize]="autoResize().enabled" autocorrect="on" spellcheck="true" autocomplete="on"></textarea>
    } @else {
    @if (type() === 'number') {
    <input class="if-input" [class.if-xs]="size() === 'xs'" [type]="'text'" [placeholder]="placeholder()"
      [disabled]="disabled" [readonly]="readonly()" [min]="min()" [max]="max()" [step]="step()" [value]="internalValue"
      (input)="onInput($event)" (blur)="onBlur()" inputNumber />
    } @else {
    <input class="if-input" [class.if-xs]="size() === 'xs'" [type]="actualInputType" [placeholder]="placeholder()"
      [disabled]="disabled" [readonly]="readonly()" [min]="min()" [max]="max()" [step]="step()" [value]="internalValue"
      (input)="onInput($event)" (blur)="onBlur()" />
    }
    }

    @if (suffix() || suffixHint()) {
      <span class="if-input-suffix-group">
        @if (suffix()) {
          <span class="if-input-suffix">{{ suffix() }}</span>
        }
        @if (suffixHint()) {
          <span class="if-input-suffix-hint">{{ suffixHint() }}</span>
        }
      </span>
    }

    @if (type() === 'password') {
    <button type="button" class="if-password-toggle" (click)="togglePasswordVisibility()" [disabled]="disabled"
      [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
      @if (showPassword) {
      <!-- Eye with slash icon placeholder -->
      <svg class="if-icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 11-4.243-4.243m4.242 4.242L9.88 9.88" />
      </svg>
      } @else {
      <!-- Eye icon placeholder -->
      <svg class="if-icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      }
    </button>
    }
  </div>

  <ng-content select=".suffix-control"></ng-content>

  @if (button()) {
  <app-button [variant]="button()!.variant" [size]="button()!.size" [disabled]="button()!.disabled || disabled"
    (click)="onButtonClick()" [class.if-gap-and-button-margin]="gapAndButtonMargin()">
    {{ button()!.label }}
  </app-button>
  }

  <ng-content select=".voice-control"></ng-content>
  <ng-content select=".button-control"></ng-content>
</div>
